import React from "react";
import PostLike from "../icons/like-icon.svg";
import CommentIcon from "../icons/comment-icon.svg";
import DateIcon from "../icons/date-icon-gray.svg";
import ArrowUp from "../icons/arrow-up.svg";
import { Button, NotFoundPage } from "../../common";
import ReactPlayer from "react-player";
import Avatar from "../../common/AvtarImage";
import { convertUTCToLocal } from "../../../utils/helper";
import appRoutes from "../../../routes/app.routes";
import { NavLink } from "react-router-dom";

interface VideoItem {
  id: number;
  user_id: number;
  video_file: string;
  video_thumbnail: string;
  title: string;
  description: string;
  is_primary: number | boolean;
  created_at: string;
}

interface videosProps {
  videos: VideoItem[];
  name: string;
  profile_image: string;
  isPublicPage: boolean;
  job_title: string;
}
function VideosCard({ videos, name, profile_image, isPublicPage, job_title }: videosProps) {
  const videoCard = ({ item, index }: { item: VideoItem; index: number }) => {
    return (
      <div className="video-card" key={index}>
        <div className="video-card-head">
          <ReactPlayer
            width="530px"
            height="287px"
            url={item.video_file}
            light={item.video_thumbnail}
            controls
          />
        </div>
        <div className="video-card-body">
          <h6>{item.title}</h6>
          <p>{item.description}</p>
          <div className="post-date">
            <div className="icon">
              <img src={DateIcon} alt="date" />
            </div>
            <span>{convertUTCToLocal(item.created_at)} ago</span>
          </div>
        </div>
        <div className="video-card-footer">
          <div className="action">
            <div className="icon">
              <img src={PostLike} alt="likes" />
            </div>
            <span>0 Likes</span>
          </div>
          <div className="action">
            <div className="icon">
              <img src={CommentIcon} alt="comment" />
            </div>
            <span>0 Comments</span>
          </div>
        </div>
      </div>
    );
  };

  return videos.length === 0 ? (
    <NotFoundPage variant="videos" />
  ) : (
    <div className="posts-wrapper">
      <div className="post-header">
        <div className="post-user-info">
          <div className="icon">
            <Avatar src={profile_image}></Avatar>
          </div>
          <div className="user-info">
            <b>{name}</b>
            <span>{job_title}</span> 
          </div>
        </div>
      </div>
      <div className="video-cards">
        {videos?.map((item, index) => videoCard({ item, index }))}
      </div>
      {
        !isPublicPage && (
      <div className="btn-wrapper">
        <NavLink to={(appRoutes as any).candidateVideos.path}>
          <Button className="all-services-btn">
            <span>See more</span>
            <img src={ArrowUp} alt="Arrow" />
          </Button>
        </NavLink>
      </div>
    )
    }
    </div>
  );
}

export default VideosCard;
